import React, { useState } from "react";
import { Badge, Button, Checkbox, Popover, Tooltip } from "antd";
import {
  ColumnWidthOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import "../../styles/column-toggle.css";

/**
 * Compact icon-only column visibility control (not db-add primary actions).
 */
function ColumnToggle({
  optionalColumns,
  hiddenKeys,
  toggleColumn,
  showAll,
  hideAll,
}) {
  const [open, setOpen] = useState(false);
  const hiddenCount = hiddenKeys.length;

  const tooltipTitle =
    hiddenCount > 0
      ? `${hiddenCount} column${hiddenCount > 1 ? "s" : ""} hidden — click to show/hide`
      : "Show / hide columns";

  const content = (
    <div className="column-toggle-popover">
      <div className="column-toggle-popover-actions">
        <button type="button" className="column-toggle-link" onClick={showAll}>
          Show all
        </button>
        <button type="button" className="column-toggle-link muted" onClick={hideAll}>
          Hide all
        </button>
      </div>

      <div className="column-toggle-checklist">
        {optionalColumns.map((col) => (
          <Checkbox
            key={col.dataIndex}
            checked={!hiddenKeys.includes(col.dataIndex)}
            onChange={() => toggleColumn(col.dataIndex)}
          >
            {col.title}
          </Checkbox>
        ))}
      </div>

      {hiddenCount > 0 && (
        <p className="column-toggle-popover-hint">
          <EyeOutlined /> {hiddenCount} column{hiddenCount > 1 ? "s" : ""} hidden
        </p>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      title="Show / hide columns"
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottomRight"
      overlayClassName="column-toggle-overlay"
    >
      <Tooltip title={tooltipTitle}>
        <Badge count={hiddenCount} size="small" offset={[-2, 2]}>
          <Button
            type="default"
            size="small"
            shape="circle"
            className={`column-toggle-btn${open ? " column-toggle-btn--open" : ""}${
              hiddenCount > 0 ? " column-toggle-btn--active" : ""
            }`}
            icon={
              hiddenCount > 0 ? (
                <EyeInvisibleOutlined />
              ) : (
                <ColumnWidthOutlined />
              )
            }
            aria-label="Show or hide table columns"
          />
        </Badge>
      </Tooltip>
    </Popover>
  );
}

export default ColumnToggle;
